module.exports = __webpack_public_path__ + "img/arrow-right.dad46dd0.svg";